<template>
	<div class="BoxBox">
		<!-- <div class="BoxBox_headerImg"></div> -->
		<div class="fts_banner_box">
			<img src="./images/fts_header_cont.png" class="fts_banner_img" />
		</div>
		<div class="springFestivalMain">
			<div class="springFestivalMainBox">

				<div class="vipCard">
					<div class="item" :class="index == 0?'itemT':index == 1?'itemY':index == 2?'itemJ':''"
						v-for="(item,index) in springFestivalData.result" :key="index">
						<div class="title"
							:class="index == 0?'titleBg1':index == 1?'titleBg2':index == 2?'titleBg3':''">
							<img class="tt" src="./images/tt.png" alt="版权登记" v-if="index == 0">
							<img class="tt" src="./images/yy.png" alt="版权登记" v-if="index == 1">
							<img class="tt" src="./images/jj.png" alt="版权登记" v-if="index == 2">
							<div class="info">
								<div :class="index==0? 'name' : index==1?'name1': index==2?'name2':''">{{item.title}}
								</div>
								<div class="msg" :class="index==0? 'name' : index==1?'name1': index==2?'name2':''">
									会员有效期：{{item.period}}{{item.periodType == 'year'?'年':'月'}}</div>
							</div>
						</div>
						<div class="moneyInfo">
							<div class="money">
								<span class="m">¥</span>
								<span class="num">{{item.value}}</span>
								<span class="m">/{{item.periodType == 'year'?'年':'月'}}</span>
								<div class="remarks"></div>
							</div>
							<div class="yuan">原价：{{item.flagValue}}元/年</div>
						</div>
						<div class="titleLine">
							<img class="line" src="./images/left.png" alt="版权登记">
							<span class="t">会员权益</span>
							<img class="line" src="./images/right.png" alt="版权登记">
						</div>
						<div class="quanInfo">
							<div class="itemInfo">
								<div class="lable">存证</div>
								<div class="num">{{item.registerVipRights.evidenceArchiveNum}}次</div>
							</div>
							<div class="itemInfo">
								<div class="lable">登记</div>
								<div class="num">{{item.registerVipRights.copyrightRegisterNum }}次</div>
							</div>
							<div class="itemInfo">
								<div class="lable">图片监测</div>
								<div class="num">{{item.registerVipRights.imageMonitorNum }}次</div>
							</div>
							<div class="itemInfo">
								<div class="lable">音乐监测</div>
								<div class="num">{{item.registerVipRights.musicMonitorNum }}次</div>
							</div>
							<div class="itemInfo">
								<div class="lable">文字监测</div>
								<div class="num">{{item.registerVipRights.textMonitorNum }}次</div>
							</div>
							<div class="itemInfo">
								<div class="lable">下载监听报告</div>
								<div class="num">
									{{item.registerVipRights.imageMonitorNum + item.registerVipRights.musicMonitorNum + item.registerVipRights.textMonitorNum }}次
								</div>
							</div>
							<div class="itemInfo">
								<div class="lable">取证</div>
								<div class="num">{{item.registerVipRights.forensicsNum }}次</div>
							</div>
							<!-- <div class="itemInfo">
								<div class="lable">电子公证</div>
								<div class="num">{{item.registerVipRights.notarizationNum }}次</div>
							</div> -->
						</div>
						<div class="infoBtn" @click="goSy(item)">立即抢购</div>
					</div>

				</div>
				<div class="vipPhone">
					<img src="./images/bg2.png" />
					<div class="contacts">
						<img src="./images/left.png" />
						<p class="contacts_title">获取更多信息 17316071137，17316071136</p>
						<img src="./images/right.png" />
					</div>
				</div>
				<div class="moreTip">
					<img src="./images/connect.png" />
				</div>
				<div class="blockCard_title">问答有礼</div>
				<div class="Discount" v-show="closeWhen==1">
					<div class="Discount_title">
						<span class="Discount_title1">
							助力知识产权日，独享4.26折限量补贴！仅限426名，惊喜开抢！
						</span>
						<span class="Discount_title2">参与版权知识问答，赢知识产权日专属福利</span>
					</div>
					<div class="Discount_grade">
						<div class="Discount_grade1">
							<div class="Discount_content" v-for='(item,index) in activityList'>
								<img class="Discount_img" :src="item.levelLogo"/>
								<span class="Discount_content_text1">{{item.levelName}}</span>
								<span class="Discount_content_text2" v-if="item.ruleNum == 0">没有蒙对</span>
								<span class="Discount_content_text2" v-else-if="totalNum && (0 < Number(item.ruleNum)) && (Number(item.ruleNum) < Number(totalNum))">部分答对</span>
								<span class="Discount_content_text2" v-else>答题满分</span>
								<span class="Discount_content_text3">{{item.valueDesc}}</span>
							</div>
						</div>
					</div>

					<div class="Discount_sub">
						
						<div class="Discount_btn2" @click="answer">{{answerText}}</div>
						<div class="Discount_btn1" @click="liulantiku">
							<span class="Discount_btn1_text">浏览题库</span>
							<img class="Discount_btn1_img" src="./images/rightAnswer.png" />
						</div>
					</div>

				</div>
				<div class="mainTitle">
					

				</div>
				<div class="cblockCard2_title">活动说明</div>
				<div class="blockCard2">
					<div class="blockCard2_top">
						<div class="right">
							<div class="textUl">
								<div class="item">
									<div class="item_icon"></div>
									<span class="item_text">活动时间：2021.4.19-2021.4.30</span>
								</div>
								<div class="item">
									<div class="item_icon"></div>
									<span class="textUI_text">所有用户均可参与本活动，该优惠活动不与其他线上优惠政策同享。</span>
								</div>
								<div class="item">
									<div class="item_icon"></div>
									<span
										class="textUI_text">活动期间内，每个用户ID可参与1次问答有礼活动，成功参与答题，按答题结果获得对应优惠奖励。</span>
								</div>
								<div class="item">
									<div class="item_icon"></div>
									<span class="textUI_text">保存荣誉海报到相册并分享朋友圈，截图发送版权家公众号客服，即可再得一张同款巨额补贴券，惊喜翻倍！</span>
								</div>
								<div class="item">
									<div class="item_icon"></div>
									<span class="textUI_text">问答有礼折扣券，自领取后有效期20天，若未经使用将自动过期。</span>
								</div>
								<div class="item">
									<div class="item_icon"></div>
									<span >参与活动时如有疑问请拨打免费客服热线：17316071137，17316071136。 </span>
								</div>
								<div class="item">
									<div class="item_icon"></div>
									<span>本活动最终解释权归北京版全家科技发展有限公司所有。</span>
								</div>

							</div>
						</div>
						<div class="left">
							<img class="bg" src="./images/activity.png" alt="版权登记">
						</div>
					</div>
					<div class="blockCard2_bottom">
						<div class="left">
							<img class="bg" src="./images/content_code.png" alt="版权登记">
						</div>
						<div class="right">
							<div class="title">关注版权家</div>
							<div class="textUl">
								<div class="item">打开微信扫一扫，关注版权家微信公众号
								</div>

							</div>

						</div>
					</div>

				</div>



				<div class="moreTip1">
					<img src="./images/connect.png" />
				</div>
				<div style="height: 169px;"></div>
			</div>
		</div>
		<div class="loginSpringFestival" v-if="closeLogInShow">
			<div class="loginForm">
				<div class="titleClose">
					<img style="cursor:pointer;" class="closeClass" @click="closeLogIn" src="./images/close.png"
						alt='版权登记' />
				</div>
				<img class="logo" src="./images/logo.png" alt='版权登记' />
				<img class="titleTip" src="./images/copyright_textimg.png" alt='版权登记' />
				<div class="htime">活动时间：2021.04.19-2021.04.30</div>
				<Form ref="mobileUpdateForm" :model="form" :rules="rules" class="formData">
					<FormItem prop="username" class="loginInput">
						<div class="item">
							<div class="lable">
								<img class="phone" src="./images/phone.png" alt="版权登记">
								<div>手机号：</div>
							</div>
							<Input class="input" v-model="form.username" placeholder="请输入手机号码" autocomplete="off" />
						</div>
					</FormItem>
					<FormItem prop="username" class="loginInput">
						<div class="msgTip">*信息保护中，请放心填写</div>
					</FormItem>
					<FormItem prop="verifyCode" class="loginInput">
						<div class="item">
							<div class="lable">
								<img class="phone" src="./images/code.png" alt="版权登记">
								<div class="lable_text">验证码：</div>
							</div>
							<Input class="input" type="text" v-model="form.verifyCode" placeholder="请输入验证码"
								autocomplete="off" />
							<input v-if="verifyCode_time >=0 && verifyCode_time <=60" v-model="verifyCode_time"
								type="button" class="loginVertial" />
							<input v-else type="button" @click.prevent="SendNumCode(7)" class="loginVertial"
								v-model="verifyCode_time">
						</div>
					</FormItem>
					<FormItem class="loginInput">
						<div class="fuxy">
							<img @click="checkchdata()" :src="checkboxmn=='Y'?ye:noye" alt='版权登记' />
							<p>阅读并同意</p>
							<a @click="lawLink">《注册协议及隐私协议》</a>
						</div>
					</FormItem>
					<FormItem>
						<div class="infoBtnPay" @click="onPayMoney()">去支付</div>
					</FormItem>
				</Form>
			</div>
		</div>
		<myPay v-if="showModal01" :subBizType="subBizType" :payMoney="payMoney" @fatherModal="fatherModal" mywidth='766'
			myHeight="425" myTitleheight="50" />
		<resSuccess :jiangliRes='jiangliRes' v-if='isShowDatisuccess' :activityId="activityId" @isSuccess="isSuccess"></resSuccess>
	</div>
</template>

<script>
	let currentDate, tempDate, ms = null;
	import resSuccess from './res.vue'
	import {
		userInfo,
		_findIndexPageShowNewNew
	} from '@/api/index.js';
	import {
		_findIndexPageShowActivity,
		sendSmsCode,
		propertyRightLogon,
		getFtsByCode,getftsConfig,getUserParticipateInfo
	} from '@/api/activity.js'
	import {
		_sysGetTime
	} from "@/api/staticPage.js";
	import Cookies from "js-cookie";
	import EventBus from "@/libs/eventBus"
	import myPay from './../vip/lawcomponent/mypay.vue';
	import myCzpay from './../vip/lawcomponent/myczpay.vue';
	import util from "@/libs/util.js";
	export default {
		metaInfo: {
			title: '版权登记|版权保护-版权服务专家',
			meta: [{ // set meta
				name: 'keyWords',
				content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
			}, {
				name: 'Description',
				content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
			}]
		},
		name: 'zhishichanquanri',
		components: {
			myPay,
			myCzpay,
			resSuccess
		},
		data() {
			return {
				springFestivalData: {},
				curStartTime: '2019-07-31 08:00:00',
				ssec: '00',
				day: '00',
				hou: '00',
				min: '00',
				sec: '00',
				endTime: '',
				_interval: null,
				form: {
					username: "",
					verifyCode: '',
				},
				rules: {
					username: [{
						required: true,
						message: " ",
						trigger: "blur"
					}],
					verifyCode: [{
						required: true,
						message: " ",
						trigger: "blur"
					}],
				},
				countdown: '',
				verifyCode_time: '获取验证码',
				answerText:'立刻答题',
				checkboxmn: 'Y',
				ye: require('@/assets/images/new_lo_b.png'),
				noye: require('@/assets/images/new_lo_hu.png'),
				closeLogInShow: false,
				showModal01: !1,
				showModal02: !1,
				saveLogin: false,
				subBizType: '',
				payMoney: '0',
				payItem: {},
				closeWhen: 1,
				activityId:"",
				activityList:[],
				isShowDatisuccess:false,
				jiangliRes:null,
				totalNum:0,
				
			}
		},
		mounted() {
			this.getWord();
			this._findIndexPageShowActivity()
//			if (this._interval) {
//				clearInterval(this._interval)
//			}
//			this.getAndSetTime();
			this._getFtsByCode()
		},
		beforeCreate() {
			if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
				let source = util.getQueryString('laiyuan');
				if (source && source != '') {
					window.location.href = `https://m.bqj.cn/pages/activity/huodong/zhishichanquanri?laiyuan=${source}`;
				} else {
					window.location.href = "https://m.bqj.cn/pages/activity/huodong/zhishichanquanri";
				}
			}
		},
		created() {
			//未登录
			//this.unloginPopup()
			//已登录        
			let aaa = 0
			EventBus.on('showModalFun', (aaa) => {
				console.log('登录了jj')
			});


			EventBus.on('logout', (aaa) => {
				console.log('退出了out')
			})
			EventBus.emit("zhishichanquanri", 'zhishichanquanri');
		},
		//当离开页面时，清除倒计时
		beforeDestroy() {
//			if (this._interval) {
//				clearInterval(this._interval)
//			}
			localStorage.setItem('zhishichanquanri', '')
			this.$bus.$off('zhishichanquanri')
		},
		methods: {
			liulantiku(){
				window.open("/wenda.html")
			},
			_getFtsByCode(){
				let _this = this;
				getFtsByCode().then((res) => {
					if(res.code == 200){
						_this.activityId = res.result.id;
						getftsConfig(res.result.id).then((result)=>{
							if(result.code ==200){
								 _this.activityList = result.result.configRewardList;
								 _this.totalNum = result.result.questionNum;
							}
						});
						let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
						if(userInfo.length == 0){
							return false;
						}
						getUserParticipateInfo(this.activityId).then((res)=>{
							console.log(res)
							if(res.code == 200){
								if(res.result != null && res.result.status == 1){
									this.answerText='领取奖励';
								}else{
									this.answerText='立刻答题';
								}
							}else{
								this.answerText='立刻答题';
							}
						})
					}
				})
			},
			//开始答题
			answer(){
				// this.$router.push('/huodong/answer.html')
				let _this = this;
				let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
				if(userInfo.length == 0){
					_this.$store.state.app.showLoginOrRegistter = true
					return false;
				}
				getUserParticipateInfo(this.activityId).then((res)=>{
					console.log(res)
					if(res.code == 200){
						if(res.result != null && res.result.status == 1){
							this.answerText='领取奖励';
							this.jiangliRes = res.result;
							this.isShowDatisuccess = true
						}else{
							this.answerText='立刻答题';
							this.$router.push('/huodong/answerQustion.html')
						}
					}else{
						this.answerText='立刻答题';
						this.$router.push('/huodong/answerQustion.html')
					}
				})
			},
			isSuccess(){
				this.isShowDatisuccess = false
			},
//			getAndSetTime() {
//				let _this = this;
//				if (!_this._interval) {
//					_this.getTimeFun();
//					let timer = setInterval(() => {
//						_this.setTimeFun()
//					}, 100)
//					_this._interval = timer;
//				}
//			},

//			setTimeFun() {
//				let that = this;
//				if (tempDate == null) {
//					return
//				} else {
//					let nowDate = new Date().getTime() + ms;
//					if (nowDate - currentDate > 1000) {
//						that.getTimeFun()
//					} else {
//						currentDate = nowDate;
//						//1619366400000
//						var date = (new Date(1619366400000)) - (currentDate);
//						if(date==0){
//							this.closeWhen=2
//						}
//						//new Date当前的时间戳，也可以换成自定义的时间戳
//						if (date > 0) {
//							let time = date / 1000;
//							// 获取时、分、秒,毫秒
//							that.day = parseInt(time / (24 * 60 * 60)) < 10 ? ('0' + parseInt(time / (24 * 60 * 60))) :
//								parseInt(time / (24 * 60 * 60)) + '';
//							that.hou = parseInt((time % (60 * 60 * 24)) / 3600) < 10 ? ('0' + parseInt((time % (60 * 60 *
//								24)) / 3600)) : parseInt((time % (60 * 60 * 24)) / 3600) + '';
//							that.min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10 ? ('0' + parseInt(((time % (
//								60 * 60 * 24)) % 3600) / 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) / 60) + '';
//							that.sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10 ? ('0' + parseInt(((time % (
//								60 * 60 * 24)) % 3600) % 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) % 60) + '';
//							that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10
//						} else {
//							//活动已结束，全部设置为'00'
//							// console.log("aaa")
//							that.day = "00",
//								that.hou = "00",
//								that.min = "00",
//								that.sec = "00";
//							clearInterval(that._interval)
//						}
//
//
//					}
//
//				}
//			},

//			/**************获取国家授时时间**************/
//			getTimeFun() {
//				_sysGetTime().then((res) => {
//					console.log(res)
//					tempDate = res ? res : new Date().getTime();
//					currentDate = new Date().getTime();
//					ms = tempDate - currentDate;
//					currentDate = currentDate + ms;
//
//
//				})
//			},
			fatherModal() {
				let _this = this;
				_this.showModal01 = !1;
				_this.showModal02 = !1;
			},
			//ucenter通信
			callChild(jscode) {

				// 传参并指定回调执行函数为onBack
				for (let j = 0, len = jscode.length; j < len; j++) {
					let script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = jscode[j] + '&callback=onBack';
					document.head.appendChild(script);
				}
			},
			onPayMoney() {
				let that = this
				let data = {
					username: that.form.username,
					verifyCode: that.form.verifyCode,
					appKey: 49497644,
					source: window.location.href
				}
				let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				if (this.form.username == '') {
					toast('请输入手机号')
					return false;
				} else if (!myreg.test(this.form.username)) {
					toast('手机号格式不正确')
					return false;
				} else if (that.form.verifyCode == '') {
					toast('验证码不能为空')
					return false;
				}
				if (this.checkboxmn == 'N') {
					toast('请勾选并同意注册协议及隐私协议')
					return false;
				}
				// 15801297662
				propertyRightLogon(data).then(res => {
					console.log(res);
					if (res.success) {
						that.setStore("accessToken", res.result);
						let jscode = res.javascript;
						that.callChild(jscode);

						// 获取用户信息
						userInfo().then(res => {
							console.log("?????????????????????", res)
							if (res.code == 200) {
								// 避免超过大小限制
								if (that.saveLogin) {
									// 保存7天
									Cookies.set("userInfo", JSON.stringify(res.result), {
										expires: 7
									});
								} else {
									Cookies.set("userInfo", JSON.stringify(res.result));
								}

								that.setStore("userInfo", res.result);
								let photo = res.result.photo ? res.result.photo : ''

								EventBus.emit("childFn", photo);

								that.$store.commit("setAvatarPath", photo);
								that.$store.state.app.showPayWay = true

								// 加载菜单
								util.initRouter(this);
								EventBus.emit("showModalFun", 'aaa');
								console.log("登陆成功拉！")
								this.closeLogInShow = !this.closeLogInShow
								that.goSy(that.payItem)
							}
						});
					} else {
						this.loading = false;
						this.isDisable = false;
						// this.getCaptchaImg();
						toast(res.message)
					}
				})
			},
			closeLogIn() {
				this.closeLogInShow = !this.closeLogInShow
			},
			lawLink() {
				window.open('/instrument/2', '_blank')
			},
			checkchdata() {
				this.checkboxmn = this.checkboxmn == 'Y' ? 'N' : 'Y'
			},
			SendNumCode(type) {
				console.log('进入');
				var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				let params;
				let _this = this
				if (this.form.username == '') {
					toast('请输入手机号')
					return false;
				} else if (!myreg.test(this.form.username)) {
					toast('手机号格式不正确')
					return false;
				} else {
					console.log('手机号格式正确')
					params = {
						mobile: this.form.username,
						type: type
					}
				}
				sendSmsCode(params).then(res => {

					if (res.code == 200) {
						toast('发送验证码成功')
						this.verifyCode_time = 60
						this.ver_disabled = 'none'
						const timer = setInterval(() => {
							if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
								this.verifyCode_time = this.verifyCode_time - 1
								console.log(this.verifyCode_time);
							} else {
								clearInterval(timer);
								this.verifyCode_time = '获取验证码'
								this.ver_disabled = 'auto'
							}
						}, 1000)
					}
				})
			},
			goSy(money) {
				console.log('-----------------', money)
				let _this = this;

				_this.payItem = money
				localStorage.setItem('zhishichanquanri', _this.$route.path)
				userInfo().then(res => {
					if (res.code == 200) {
						Cookies.set("userInfo", JSON.stringify(res.result));
						_this.setStore("userInfo", res.result);
						let userInfo = res.result;
						if (userInfo == '') {
							toast('请登录后再操作')
							return false;
						}
						if (userInfo.vipFlag) {
							this.showModal01 = !0;
							this.showModal02 = !0
						}
						this.subBizType = money.code

						this.payMoney = money.value
					} else {
						_this.closeLogInShow = !_this.closeLogInShow
					}
				})
			},
			_findIndexPageShowActivity() {
				let that = this
				let data = {
					subBizType: 1602
				}
				_findIndexPageShowActivity(data).then(res => {
					console.log(res, 789)
					that.springFestivalData = res
				})
			},
			//截取百度搜索关键字
			queryString(parm, parm2) {
				var baiduKeyWords = "";
				let fromUrl = parm2.split("?");
				let fromUrl2 = fromUrl[1].split("&");
				let wordsArr = fromUrl2.filter(item => item.match(parm))
				let wordsArr2 = wordsArr.join("").split("=")
				return baiduKeyWords = wordsArr2[1]
			},
			//获取跳转到版权家官网首页的路径
			getWord() {
				if (window.document.referrer) {
					// 获取上级页面
					let url = document.referrer;
					// 判断是不是百度的域名
					if (url.match("www.baidu.com")) {
						// 第一个参数是百度的get参数wd拼接的关键词
						let mywords = this.queryString("wd", url);
						if (mywords != '') console.log(decodeURI(mywords));
						// 判断是不是百度手机端
					} else if (url.match("m.baidu.com")) {
						let mywords = this.queryString("word", url);
						if (mywords != '') console.log(decodeURI(mywords));
					} else {
						console.log(url + '不是从百度搜索来的')
					}
				} else {
					console.log("没有document.referrer属性")
				}
			},

			//跳转页面方法
			jumpRouter(url) {
				window.open(url)
			}
		},
		beforeDestroy() {
			EventBus.off('showModalFun');

			EventBus.off('logout')
		},

	}
</script>

<style scoped lang="less">
	.Discount {
		width: 1190px;
		margin: -50px auto 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: url(./images/discount_show.png);
		background-size: 1198px 604px;
		background-repeat: no-repeat;
		border-radius: 4px;

		height: 604px;
	}

	.Discount_grade1 {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.Discount_content_text3 {
		margin-top: 20px;
		font-size: 32px;
		font-weight: bold;
		color: #FF3E50;
		height: 33px;
	}

	.Discount_content_text2 {
		margin-top: 12px;
		font-size: 14px;
		font-weight: 400;
		color: #7A4D13;
		height: 13px;
	}

	.Discount_content_text1 {
		margin-top: 7px;
		font-size: 20px;
		font-weight: 400;
		color: #7A4D13;
		height: 19px;
	}

	.Discount_grade_mar {
		margin-left: 191px;
	}

	.Discount_grade {
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		height: 254px;
		margin-top: 47px;
	}

	.Discount_title {
		margin-top: 101px;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.Discount_title2 {
		font-size: 18px;
		font-weight: 400;
		color: #333333;

	}

	.Discount_title1 {
		font-size: 20px;
		font-weight: 600;
		color: #333333;
		padding-bottom: 14px;
	}

	.Discount_titl2 {
		font-size: 16px;
		color: #000;
		margin-top: 10px;

	}

	.Discount_sub {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 39px 0 39px 0;
	}

	.Discount_btn1 {
		font-size: 16px;
		font-weight: 400;
		color: #999999;
		cursor: pointer;
		margin:15px 0 0 0;
		display: flex;
		align-items: center;
		justify-content: center;
		vertical-align: middle;
		text-align: center;
	}
	.Discount_btn1_text{
		font-size: 16px;
		font-weight: 400;
		color: #999999;
		vertical-align: middle;
	}
	.Discount_btn1_img{
		width: 14px;
		height: 14px;
		margin: 0 0 0 5px;
		vertical-align: middle;
	}
	.Discount_btn2 {
		width: 274px;
		height: 44px;
		background: linear-gradient(0deg, #FDCA4F 0%, #FEE571 60%, #FDF0B1 100%);
		border-radius: 22px;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: #7A4D13;
		line-height: 44px;
		text-align: center;
		cursor:pointer;
	}

	.Discount_content {
		display: flex;
		flex-direction: column;
		justify-content: start;
		align-items: center;
		&:not(:first-child){
			margin-left: 191px;
		}
	}

	.Discount_img {
		width: 172px;
		height: 140px;
	}

	.BoxBox {
		min-width: 1344px;
		background: url(./images/bigbg1.png) no-repeat;
		background-size: 100% 100%;
		position: relative;
	}

	.fts_banner_box {
		width: 100%;
		height: 995px;
		background: url(./images/fts_header_bg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;

		.fts_banner_img {
			width: 1200px;
			height: 614px;
			margin: auto;
			display: block;
		}

	}

	.springFestivalMain {
		// background: url('./images/mainbg.jpg') no-repeat;
		background-size: 100% 100%;
		// position: relative;
		margin-top: -470px;

		// z-index: 101;
		.springFestivalMainBox {
			width: 1344px;
			margin: auto;
			padding: 60px 0;


			.mainTitle {
				.box {
					display: flex;
					align-items: center;
					justify-content: center;

					.text {
						font-size: 26px;
						position: relative;
						z-index: 9;
						font-weight: bold;
						color: #fff;

						.line {
							width: 100%;
							height: 8px;
							background: #FFD800;
							position: absolute;
							left: 0;
							bottom: 5px;
							z-index: -1;
						}
					}
				}

				.ytime {
					font-size: 14px;
					text-align: center;
					color: #fff;
					margin: 12px 0;
				}
			}

			.newBox {
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					background: #de292d;
					color: #FFD800;
					border: solid 1px #FFD800;
					font-size: 27px;
					font-weight: bold;
					width: 50px;
					height: 50px;
					line-height: 50px;
					text-align: center;
					border-radius: 100%;
					margin-left: -5px;
				}
			}

			.vipCard {
				display: flex;
				display: -webkit-flex;
				align-items: center;
				justify-content: center;
				margin-top: 50px;

				.item {
					width: 385px;
					height: 694px;

					.title {
						background-size: 100% 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 12px 0;
						margin-top:11px;

						.tt {
							width: 60px;
							height: 70px;
						}

						.info {
							padding: 0 20px;
							box-sizing: border-box;
							.name {
								font-size: 18px;
								font-weight: bold;
								color: #7A4F2D;
							}

							.name1 {
								font-size: 18px;
								font-weight: bold;
								color: #6D727C;
							}

							.name2 {
								font-size: 18px;
								font-weight: bold;
								color: #7F6743;
							}

							.msg {
								font-size: 14px;

								margin-top: 6px;
							}
						}
					}

					.moneyInfo {
						padding: 30px 0;

						.money {
							display: flex;
							color: #FF3E50;
							align-items: baseline;
							justify-content: center;
							margin-left: 65px;

							.m {
								font-size: 16px;
							}

							.num {
								font-size: 48px;
								font-weight: bold;
								padding: 0 4px;
							}

							.remarks {
								background: url(./images/Discount.png) no-repeat;
								font-size: 12px;
								color: #fff;
								background-size: 62px 18px;
								width: 62px;
								height: 18px;
								line-height: 20px;
								text-align: center;
								padding-left: 10px;
								margin-left: 10px;
								// width: 61px;
								// height: 16px;
								// background: linear-gradient(90deg,#FF0F47 , #FFAB96);
								// border-radius: 7px;
								// border: none;
								// margin-left: 7px;
								// font-size: 10px;
								// font-family: Source Han Sans CN;
								// font-weight: bold;
								// color: #FFFFFF;
								// line-height: 18px;
								// .content{



							}
						}

						.yuan {
							font-size: 14px;
							text-decoration: line-through;
							color: #999999;
							text-align: center;
						}
					}

					.titleLine {
						display: flex;
						align-items: center;
						justify-content: center;

						.line {
							width: 97px;
							height: 15px;
							display: block;
						}

						.t {
							font-size: 18px;
							font-weight: bold;
							color: #333;
							padding: 0 15px;
						}
					}

					.quanInfo {
						width: 249px;
						margin: auto;
						padding-top: 30px;

						.itemInfo {
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-size: 14px;
							color: #333;
							margin-bottom: 15px;
						}
					}

					.infoBtn {
						font-size: 14px;
						width: 249px;
						margin: 30px auto;
						color: #7A4D13;
						font-size: 16px;
						font-weight: 400;
						text-align: center;
						line-height: 44px;
						border-radius: 4px;
						cursor: pointer;
						// background: url(./images/btbg.png) no-repeat;
						background: linear-gradient(to bottom, #FDF0B1, #FEE571, #FDCA4F);
						border-radius: 20px;

					}
				}

				.itemT {
					background: url(./images/vip1.png) no-repeat;
					background-size: 100% 100%;
				}

				.itemY {
					background: url(./images/vip2.png) no-repeat;
					background-size: 100% 100%;
					margin-left: 22px;
					margin-right: 22px;
				}

				.itemJ {
					background: url(./images/vip3.png) no-repeat;
					background-size: 100% 100%;
				}
			}

			.vipPhone {
				text-align: center;
				margin-top: 11px;

				.contacts {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: -60px;

					.contacts_title {
						margin: 0 36px 0 36px;
						font-size: 20px;
						font-weight: 400;
						color: #7A4D13;

					}
				}
			}

			.moreTip {
				padding: 40px 0;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: -125px;
			}

			.blockCard_title {
				margin: 79px 0 0 0;
				font-size: 24px;
				font-weight: bold;
				color: #B25629;
				text-align: center;
			}

			.blockCard {
				width: 1190px;
				margin: -50px auto 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-evenly;
				background: url(./images/answer.png);
				background-size: 1190px 441px;
				border-radius: 4px;

				height: 441px;

				.left {
					color: #333;
					font-size: 24px;
					margin-top: 111px;
					margin-bottom: 49px;
					font-weight: 600;

					.bg {
						width: 311px;
						height: 216px;
						display: block;
						margin-left: 152px;
					}

					.code {
						width: 112px;
						height: 112px;
						position: absolute;
						right: 6px;
						top: 20px;
					}
				}

				.right {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-bottom: 39px;

					.right_date {
						width: 114px;
						height: 128px;
						background: linear-gradient(0deg, #3BC1ED 0%, #325FF3 100%);
						border-radius: 10px;
						margin: 0 21px;


						font-size: 77px;
						font-weight: 800;
						color: #FFFFFF;
						line-height: 114px;
						text-align: center;

					}

					.right_text {
						width: 28px;
						height: 28px;
						font-size: 31px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #999999;

					}

					.title {

						font-size: 16px;
						font-weight: bold;
					}
				}

				.right_col {

					font-size: 18px;
					// font-family: PingFang SC;
					font-weight: 600;
					color: #FF3E50;
					margin-bottom: 47px;

				}

				.textUl {
					font-size: 14px;
					width: 481px;
					margin-top: 15px;
					padding-right: 72px;

					.item {
						margin-bottom: 8px;
						color: #404E57;
					}

					.item1 {
						margin-bottom: 8px;
						color: #000;
						font-weight: 550;
					}
				}
			}

			.cblockCard2_title {
				margin: 70px 0 0 0;
				font-size: 24px;
				font-weight: bold;
				color: #B25629;
				text-align: center;
			}

			.moreTip1 {
				padding: 40px 0;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: -300px;
			}

			.blockCard2 {
				width: 1190px;
				background: url(./images/bg4.png);
				background-size: 1190px 648px;
				border-radius: 4px;
				height: 648px;
				margin: -50px auto;
				padding-top: 93px;

				.blockCard2_top {
					display: flex;
					align-items: start;
					justify-content: space-evenly;

					.left {
						position: relative;

						.bg {
							width: 275px;
							height: 243px;
							display: block;
							margin-right: 158px;
						}
					}

					.right {
						margin-right: 100px;

						.title {
							color: #FE8C00;
							font-size: 18px;
							font-weight: bold;
						}
					}

					.textUl {
						font-size: 14px;
						

						.item {
							margin-bottom: 12px;
							display: flex;
							justify-content: left;
							align-items: flex-start;

							.item_icon {
								width: 11px;
								height: 11px;
								border: 3px solid #FED257;
								border-radius: 50%;
								margin: 4px 11px 0 106px;

								span {
									font-size: 14px;
								}
							}

							.textUI_text {
								width: 470px;
								font-size: 14px;
								font-weight: 400;
								color: #404E57;
							}

							.item_text {
								font-size: 16px;
								color: #404E57;
								font-weight: bold;
							}
						}
					}
				}

				.blockCard2_bottom {
					display: flex;
					align-items: start;
					justify-content: space-evenly;
					margin:93px 0 0 154px;

					.left {
						position: relative;

						.bg {
							width: 332px;
							height: 170px;
							display: block;
							margin:-10px  161px 0 0;
						}
					}

					.right {
						margin-right: 290px;

						.title {

							font-size: 20px;
							font-weight: bold;
							color: #404E57;
							line-height: 24px;
							margin:50px 0 20px 0;
						}

						.textUl {
							.item {
								font-size: 14px;
								font-weight: 400;
								color: #404E57;
							}
						}
					}
				}


			}
		}
	}

	.loginSpringFestival {
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		margin: auto;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 666;

		.loginForm {
			width: 480px;
			height: 552px;
			background: #ffffff;
			position: absolute;
			top: 50%;
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
			left: 0;
			right: 0;
			margin: auto;
			border-radius: 6px;
			background: url(./images/tankuang.png) no-repeat;
			background-size: 100% 100%;


			.titleClose {
				position: relative;
				height: 43px;

				.closeClass {
					width: 18px;
					height: 18px;
					position: absolute;
					right: 20px;
					top: 20px;
				}
			}

			.logo {
				width: 180px;
				height: 29px;
				display: block;
				margin: 0 auto;
			}

			.titleTip {
				width: 408px;
				height: 45px;
				display: block;
				margin: 21px auto 10px auto;
			}

			.htime {
				color: #FCFEEA;
				font-size: 14px;
				text-align: center;
				margin-bottom: 17px;
				height: 14px;
			}

			.formData {
				margin: 0 30px;
				background: #fff;
				border-radius: 12px;
				padding: 49px 50px 0 50px;

				.loginInput {
					margin-bottom: 0;

					.msgTip {
						height: 15px;
						font-size: 14px;
						color: #F01C1D;

						line-height: 15px !important;
						margin: 16px 0 15px 39px;
					}

					.item {
						position: relative;
						line-height: 40px;
						height: 39px;
						font-size: 14px;

						.lable {
							display: flex;
							align-items: center;
							color: #666666;
							font-size: 14px;
							position: absolute;
							z-index: 9;
							left: 12px;
							width: 100px;

							.phone {
								width: 20px;
								height: 20px;
								margin-right: 7px;
							}

							.lable_text {}
						}

						.input {
							width: 331px;
							height: 41px;
							position: absolute;
							left: 0;
							top: 0;


							/deep/ .ivu-input {
								position: absolute;
								left: 0;
								top: 0;
								z-index: 3;
								text-indent: 76px;
								height: 40px;
								line-height: 40px;
								padding-left: 23px;
							}
						}

						.loginVertial {
							position: absolute;
							width: 85px;
							background: rgba(240, 240, 240, 1);
							right: -1px;
							top: 6px;
							text-align: center;
							font-size: 12px;
							font-weight: 400;
							color: rgba(51, 51, 51, 1);
							cursor: pointer;
							border: none;
							outline: none;
							z-index: 10;
							border-radius: 14px;
							height: 28px;
							line-height: 28px;
						}

						.loginlabel {
							position: absolute;
							left: 10px;
							width: 56px;
							font-size: 14px;
							font-weight: 400;
							color: #666666;
							z-index: 5;
							height: 38px;
							line-height: 38px;

							/deep/ .ivu-input {
								position: absolute;
								left: 0;
								z-index: 3;
								text-indent: 76px;
								padding-left: 23px;
							}
						}
					}
				}

				.fuxy {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					margin: 35px 0 0 15px;

					img {
						margin-right: 10px;
					}

					p {
						height: 20px;
						font-size: 14px;
						font-weight: 400;
						color: rgba(153, 153, 153, 1);
						line-height: 20px;
					}

					a {
						height: 20px;
						font-size: 14px;
						font-weight: 400;
						color: #009AFF;
						line-height: 20px;
					}
				}

				.infoBtnPay {
					font-size: 14px;
					width: 330px;
					background: #009AFF;
					margin: 35px auto 51px;
					color: #fff;
					text-align: center;
					height: 40px;
					line-height: 40px;
					border-radius: 4px;
					cursor: pointer;

					&:hover {
						// background: rgba(240, 28, 29, 0.7);
					}
				}
			}

		}
	}
</style>
